<div class="container faculty-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="fas fa-chalkboard-teacher"></i>
      </div>
      <div class="header-text">
        <h2 class="page-title">Our Faculty</h2>
        <p class="page-subtitle">Meet our dedicated team of pharmaceutical educators and experts</p>
      </div>
    </div>
  </div>

  <!-- Teaching Faculty Section -->
  <div class="faculty-section">
    <div class="section-header">
      <div class="section-icon">
        <i class="fas fa-user-graduate"></i>
      </div>
      <h3 class="section-title">Teaching Faculty</h3>
    </div>
    <div class="row faculty-row">
      <div class="col-lg-4 col-xl-3 faculty-col" *ngFor="let member of faculty_details; let i = index">
        <mat-card class="faculty-card">
          <div class="card-image-wrapper">
            <img mat-card-md-image [src]="member.img" [alt]="member.name" class="faculty-image">
            <div class="image-overlay">
              <i class="fas fa-user-circle"></i>
            </div>
          </div>
          <mat-card-header>
            <mat-card-title-group>
              <mat-card-title class="faculty-name">{{member.name}}</mat-card-title>
              <mat-card-subtitle class="faculty-designation">
                <i class="fas fa-briefcase me-1"></i>{{member.designation}}
              </mat-card-subtitle>
              <mat-card-subtitle class="faculty-qualification">
                <i class="fas fa-graduation-cap me-1"></i>{{member.qualification}}
              </mat-card-subtitle>
            </mat-card-title-group>
          </mat-card-header>
        </mat-card>
      </div>
    </div>
  </div>

  <!-- Non-Teaching Faculty Section -->
  <div class="faculty-section">
    <div class="section-header">
      <div class="section-icon">
        <i class="fas fa-user-tie"></i>
      </div>
      <h3 class="section-title">Non-Teaching Faculty</h3>
    </div>
    <div class="row faculty-row">
      <div class="col-lg-4 col-xl-3 faculty-col" *ngFor="let member of nonteaching; let i = index">
        <mat-card class="faculty-card">
          <div class="card-image-wrapper">
            <img mat-card-md-image [src]="member.img" [alt]="member.name" class="faculty-image">
            <div class="image-overlay">
              <i class="fas fa-user-circle"></i>
            </div>
          </div>
          <mat-card-header>
            <mat-card-title-group>
              <mat-card-title class="faculty-name">{{member.name}}</mat-card-title>
              <mat-card-subtitle class="faculty-designation">
                <i class="fas fa-briefcase me-1"></i>{{member.designation}}
              </mat-card-subtitle>
              <mat-card-subtitle class="faculty-qualification">
                <i class="fas fa-graduation-cap me-1"></i>{{member.qualification}}
              </mat-card-subtitle>
            </mat-card-title-group>
          </mat-card-header>
        </mat-card>
      </div>
    </div>
  </div>

  <!-- Non-Teaching Staff Section -->
  <div class="faculty-section">
    <div class="section-header">
      <div class="section-icon">
        <i class="fas fa-users"></i>
      </div>
      <h3 class="section-title">Non-Teaching Staff</h3>
    </div>
    <div class="row faculty-row">
      <div class="col-lg-4 col-xl-3 faculty-col" *ngFor="let member of attendant; let i = index">
        <mat-card class="faculty-card">
          <div class="card-image-wrapper">
            <img mat-card-md-image [src]="member.img" [alt]="member.name" class="faculty-image">
            <div class="image-overlay">
              <i class="fas fa-user-circle"></i>
            </div>
          </div>
          <mat-card-header>
            <mat-card-title-group>
              <mat-card-title class="faculty-name">{{member.name}}</mat-card-title>
              <mat-card-subtitle class="faculty-designation">
                <i class="fas fa-briefcase me-1"></i>{{member.designation}}
              </mat-card-subtitle>
              <mat-card-subtitle class="faculty-qualification" *ngIf="member.qualification">
                <i class="fas fa-graduation-cap me-1"></i>{{member.qualification}}
              </mat-card-subtitle>
            </mat-card-title-group>
          </mat-card-header>
        </mat-card>
      </div>
    </div>
  </div>

</div>